import { S2STopbar } from './core/component';
import { getLoaderScript, resolveDefaultTopbarSrc } from './utils/loader';

// Registers the custom element and leaves a global hook for manual control/debugging.
export function defineTopbarElement() {
  if (!customElements.get('s2s-topbar')) customElements.define('s2s-topbar', S2STopbar);
  (window as any).S2STopbar = S2STopbar;
}

// Automatically insert <s2s-topbar> into the page body using data attributes for config.
export function autoMount() {
  if (document.querySelector('s2s-topbar')) return;

  const loaderScript = getLoaderScript();
  const ds = (loaderScript?.dataset as any) || {};
  let src = ds.src;
  let dropdownSrc = ds.dropdownSrc;
  if (!src) src = resolveDefaultTopbarSrc(loaderScript) || undefined;
  const noOffset = ds.noOffset !== undefined;

  const el = document.createElement('s2s-topbar');
  if (src) el.setAttribute('src', src);
  if (dropdownSrc) el.setAttribute('dropdown-src', dropdownSrc);
  if (noOffset) el.setAttribute('no-offset', '');

  // Optional ribbon configuration via script data attributes
  if (ds.ribbonColor) el.setAttribute('ribbon-color', ds.ribbonColor);
  if (ds.accountName) el.setAttribute('account-name', ds.accountName);
  if (ds.accountId) el.setAttribute('account-id', ds.accountId);
  if (ds.userRole) el.setAttribute('user-role', ds.userRole);
  if (ds.userinfoSrc) el.setAttribute('userinfo-src', ds.userinfoSrc);

  const target = document.body;
  if (target.firstChild) target.insertBefore(el, target.firstChild);
  else target.appendChild(el);
}
